import { createSlice } from "@reduxjs/toolkit";
const initialAppState = {
  appId: null,
  productType: null,
  subProductType: null,
  currentAccountWarningShown: false,
};
export const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState: initialAppState,
  reducers: {
    setProductType(state, action) {
      state.productType = action?.payload;
    },
    setAppId(state, action) {
      state.appId = action?.payload;
    },
    setSubProductType(state, action) {
      state.subProductType = action?.payload;
    },
    setCurrentAccountWarningShown(state, action) {
      state.currentAccountWarningShown = action?.payload;
    },
  },
});

export const { setProductType, setAppId, setSubProductType, setCurrentAccountWarningShown } = applicationSlice.actions;